module.exports = __webpack_public_path__ + "static/media/e27.02619df9.png";